import * as React from 'react';
import Grid from '@mui/material/Grid';

const SEPlayListContainer = ({ children }) => {
    return (
        <Grid
            display={'flex'}
            justifyContent={'center'}
            flexWrap={'wrap'}
            maxWidth="100%"
            sx={{
                border: '2px dashed rgba(0, 0, 0, 0.12)',
                borderRadius: ' 4px'
            }}
        >
            <ul
                aria-label={'image-list'}
                className={'seplay-listgrid-ul'}
                style={{ display: 'flex', flexWrap: 'wrap' }}
            >
                {children}
            </ul>
        </Grid>
    );
};

export default SEPlayListContainer;
